import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Box,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Text,
  HStack,
  Spacer
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt, faArrowCircleDown, faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";

import CoreService from "../../../../services/CoreService";

const columns = [
  { dataField: "source", text: "" },
  { dataField: "dtd", text: "Today" },
  { dataField: "wtd", text: "Week" },
  { dataField: "mtd", text: "Month" },
  { dataField: "ytd", text: "Year" },
  { dataField: "ltd", text: "Lifetime"}
];

export default class EnterpriseTotalsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [{ source: "Totals", dtd: 0, wtd: 0, mtd: 0, ytd: 0, ltd: 0 }],
      totalsOnly: true,
      isLoading: true
    };
    this.coreService = new CoreService();

    this.renderRows = this.renderRows.bind(this);
    this.toggleTotalsOnly = this.toggleTotalsOnly.bind(this);
    this.fetchTotalsOnly = this.fetchTotalsOnly.bind(this);
  }

  async componentDidMount() {
    var newTableDataResult = await this.coreService.fetchToDateLocationData(this.props.userSession.gcid, this.props.userSession.token);
    var newTableData = newTableDataResult.dataResult;
    this.setState({
      tableData: newTableData,
      isLoading: false
    });
  }


  toggleTotalsOnly() {
    let newTotalsOnly = (!this.state.totalsOnly);
    this.setState({ totalsOnly: newTotalsOnly });
  }


  fetchTotalsOnly() {
    let totalsRw = this.state.tableData.find((rw) => {
      return rw.source === "Totals";
    });
    let result = [];
    result.push(totalsRw);
    return result;
  }


  renderRows() {
    var rowsToRender = (this.state.totalsOnly) ? this.fetchTotalsOnly() : this.state.tableData;
    let result = rowsToRender.map((rw, idx) => {
      return (
        <Tr key={rw.source}>
          <Td style={{ padding: "2px", textAlign: "left"  }}>{rw.source}</Td>
          <Td style={{ padding: "2px", textAlign: "right"  }}>{rw.dtd}</Td>
          <Td style={{ padding: "2px", textAlign: "right"  }}>{rw.wtd}</Td>
          <Td style={{ padding: "2px", textAlign: "right"  }}>{rw.mtd}</Td>
          <Td style={{ padding: "2px",  textAlign: "right" }}>{rw.ytd}</Td>
          <Td style={{ padding: "2px", textAlign: "right"  }}>{rw.ltd}</Td>
        </Tr>
      )
    })
    return result;
  }

  render() {

    const loadingIcon = (this.state.isLoading) ?
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin /> :
      ""

    return (
      <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>
        <HStack>
          <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Enterprise Totals</Text>
          <Spacer/>
          {loadingIcon}
          <FontAwesomeIcon icon={(this.state.totalsOnly) ? faArrowCircleDown : faArrowCircleUp} color="white" onClick={(e) => this.toggleTotalsOnly(e)} />
        </HStack>
        <Table style={{ fontSize: 12, backgroundColor:'white'}} variant='striped' colorScheme='blue'>
          <Thead>
            <Tr>
              <Th style={{ padding: "2px",  }}></Th>
              <Th style={{ padding: "2px", textAlign: "right" }}>Today</Th>
              <Th style={{ padding: "2px",  textAlign: "right" }}>Week</Th>
              <Th style={{ padding: "2px", textAlign: "right"  }}>Month</Th>
              <Th style={{ padding: "2px", textAlign: "right"  }}>Year</Th>
              <Th style={{ padding: "2px",  textAlign: "right" }}>Lifetime</Th>
            </Tr>
          </Thead>
          <Tbody>
            {this.renderRows()}
          </Tbody>

        </Table>


      </Box >
    );
  }
}
